import React, { Component } from "react";

class Navbar extends Component {
  render() {
    return (
      <header className="navbar navbar-expand-lg" style={{ position: 'fixed', top: 0, left: 0, width: '100%', background: '#fff', zIndex: 999, boxShadow: 'rgba(0,0,0,0.1) 0px 0px 20px' }}>
        <div className="container position-relative">
          <a className="navbar-brand" href="/">
            <img
              className="navbar-brand-regular"
              src={this.props.imageData}
              alt="brand-logo"
            />
            <img
              className="navbar-brand-sticky"
              src="/img/logo.png"
              alt="sticky brand-logo"
            />
          </a>
          <button
            className="navbar-toggler d-lg-none"
            type="button"
            data-toggle="navbarToggler"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="navbar-inner">
            {/*  Mobile Menu Toggler */}
            <button
              className="navbar-toggler d-lg-none"
              type="button"
              data-toggle="navbarToggler"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <nav>
              <ul className="navbar-nav" id="navbar-nav">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="/"
              
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/features">
                    Features
                  </a>
                </li>

                <li className="nav-item">
                  <a className="nav-link" href="/policiesandcodes">
                    Policies & Codes
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/faq">
                    FAQ
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/blog">
                    Blog
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/contact-page">
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    );
  }
}

export default Navbar;
